import { render, staticRenderFns } from "./KegiatanPelayananJiwa.vue?vue&type=template&id=142b8aed"
import script from "./KegiatanPelayananJiwa.vue?vue&type=script&lang=js"
export * from "./KegiatanPelayananJiwa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('142b8aed')) {
      api.createRecord('142b8aed', component.options)
    } else {
      api.reload('142b8aed', component.options)
    }
    module.hot.accept("./KegiatanPelayananJiwa.vue?vue&type=template&id=142b8aed", function () {
      api.rerender('142b8aed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanPelayananJiwa.vue"
export default component.exports